import React, { useState } from 'react';
import { useQuery } from '@apollo/client';

import { Text,MixedGridGroup } from 'quanta-ui';

import QuoteData from './quote-data';

import {
  APPLICABLE_COVERS,
  CHARACTER_LIMIT_LIST,
  GET_FIELDUSER_LIST,
  GET_PCV_POLICY_VAR_DETAILS,
} from '../../queries';
import {Loading} from 'quanta-flows/modules/layout';
import {Error} from 'quanta-flows/modules/layout';
import CoversForm from './covers-form';
//import useFetchQuery from './lib/graphql/useFetchCacheQuery';
import { useFetchQuery } from 'quanta-flows';

export default function Covers({
  goToStep,
  productCode,
  productName,
  lobCode,
  quoteNumber,
  lobName,
  modify,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const [loadingCovers, setLoadingCovers] = useState(false);
  const [errorCovers, setErrorCovers] = useState(null);
  const [coversInfo, setCoversInfo] = useState(null);
  const [initLoad, setInitLoad] = useState(true);
  const [fieldUserList, setFieldUserList] = useState([]);
  const {
    loading: loadingMotorQuote,
    error: errorMotorQuote,
    data: dataMotorQuote,
    previousData: previousDataMotorQuote,
  } = useQuery(GET_PCV_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: !initLoad,
    onCompleted: async (data) => {
      const { motorQuote, selectedIntermediary } = data;
      try {
        setErrorCovers(null);
        const applicableCoversQuery = fetchQuery({
          query: APPLICABLE_COVERS,
          fetchPolicy: 
          data?.motorQuote?.quotationNo
            ? 'cache-first'
            : 
            'network-only',
          variables: {
            input: {
            productCode
          :motorQuote?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
          ?'3183'
          :motorQuote?.productVariant?.toLowerCase()?.search('liability') !== -1
          ?'3184'
          :'3183',
         
              productType: data?.motorQuote?.productType,
              intermediaryCode:
                data?.selectedIntermediary?.intermediaryCode,
              fuelType: data?.motorQuote?.fuelType,
            },
          },
        });
        const getFieldUserList = fetchQuery({
          query: GET_FIELDUSER_LIST,
          variables: {
            input: {
              intermediaryCode: (motorQuote?.intermediaryDetails?.code || selectedIntermediary?.intermediaryCode),
              officeId: (motorQuote?.intermediaryDetails?.location || selectedIntermediary?.branchOfficeCode)
            }
          }
        });
        setLoadingCovers(true);
        const { data: coversData } = await applicableCoversQuery;
        const { data: dataFieldUserList } = await getFieldUserList;
        setInitLoad(false);
        setFieldUserList(dataFieldUserList?.getFiledUserByIMID);
        setLoadingCovers(false);
        setCoversInfo(coversData);
      } catch (error) {
        setLoadingCovers(false);
        setErrorCovers(error?.message);
      }
    },
  });
  const {
    loading: loadingNameLimit,
    error: errorNameLimit,
    data: dataNameLimit,
    previousData: previousDataNameLimit
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
    //  skip: !initLoad
  });

  if (loadingCovers || loadingMotorQuote || loadingNameLimit)
    return (
      <div className="min-h-screen">
        <Loading
          customMessage={
            quoteNumber ? 'Loading' : 'Looking for applicable covers'
          }
        />
      </div>
    );
  if (errorCovers || errorMotorQuote || errorNameLimit) {
    let error = {
      message: `There was an issue fetching the applicable covers. Please try again after some time...`,
    };
    return <Error error={error} />;
  }

  const { motorQuote, selectedIntermediary } = dataMotorQuote
    ? dataMotorQuote
    : previousDataMotorQuote;
  const { characterLimitList } = dataNameLimit ? dataNameLimit: previousDataNameLimit;

  return coversInfo && coversInfo?.applicableCovers ? (   
    <div>
      <QuoteData
        goToStep={goToStep}
        forwardedCoversFormRef={props?.forwardedCoversFormRef}
        lobCode={lobCode}
        lobName={lobName}
        quoteNumber={quoteNumber}
        productCode={productCode}
        productName={productName}
	  modify={modify}
      />
      <div className="mt-6">
        <Text type="title" severity="info">
          We have found below covers for your selection
        </Text>
      </div>
      <div className="mt-2">
        <CoversForm
          tenureList={coversInfo?.applicableCovers?.tenure}
          riskCovers={coversInfo?.applicableCovers?.riskCovers}
          productCode={productCode}
          productName={productName}
          lobCode={lobCode}
          lobName={lobName}
          quoteNumber={quoteNumber}
          motorQuote={motorQuote}
          selectedIntermediary={selectedIntermediary}
          fieldUserList={fieldUserList}
          characterLimitList={characterLimitList}
          forwardedCoversFormRef={props?.forwardedCoversFormRef}
          modify={modify}
        />
      </div>
    </div>
    
  ) : null;
  
}
